module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy42NDUiIGhlaWdodD0iMjMuMzAxIiB2aWV3Qm94PSIwIDAgMTcuNjQ1IDIzLjMwMSI+PHBhdGggZD0iTTEzLjE4MSAyMi4zMzVhMi44MTcgMi44MTcgMCAwIDEtMi44MTctMi44MTZWNC4wMWEyLjgxNiAyLjgxNiAwIDEgMSA1LjYzNCAwdjE1LjUwOWEyLjgxNyAyLjgxNyAwIDAgMS0yLjgxNyAyLjgxNnptLTkuNTUzIDBhMi44MTcgMi44MTcgMCAwIDEtMi44MTctMi44MTZWNC4wMWEyLjgxNiAyLjgxNiAwIDEgMSA1LjYzNCAwdjE1LjUwOWEyLjgxNyAyLjgxNyAwIDAgMS0yLjgxNyAyLjgxNnoiIGZpbGw9IiNGQzhCNjAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/player-pause.svg
// module id = 107
// module chunks = 0